import MainLayout from "@/components/layout/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import store from "@/store";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "detailTeacher",

    components: {
        MainLayout
    },

    data() {
        return {
            teacher: {},
            reloadKey: 0,
            regionArr: RegionJson
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getDetailTeacher() {
            // axios.get("/teacher/profile/" + this.teacherId)
            axios.get("/profile")
                .then((response) => {
                    this.teacher = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Teacher Detail API Error", error);
                });
        },
        
        checkTeacherToken(token) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            axios.get("/token/teacher")
                .then((response) => {
                    response.data.token = token;
                    store.commit("setUserData", response.data);
                    this.teacher = response.data.teacher;
                    this.reloadKey += 1;
                    this.$router.push({ name: "detailTeacher" });
                })
                .catch((error) => {
                    console.log("Teacher Detail API Error", error);
                });
        },
    },

    created() {
        fetchNotificationCount();

        if (this.$route.query.token) {
            this.checkTeacherToken(this.$route.query.token);
        } else {
            this.getDetailTeacher();
        }
    }
};
